import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

function deepMerge(target, ...sources) {
  if (!sources.length) return target;

  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else if (Array.isArray(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: [] });
        }
        // 合并数组
        target[key] = [...new Set([...target[key], ...source[key]])];
      } else if (source[key] instanceof Date) {
        // 处理日期对象
        target[key] = new Date(source[key]);
      } else if (source[key] instanceof RegExp) {
        // 处理正则表达式
        target[key] = new RegExp(source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
}

function isObject(item) {
  return (item && typeof item === 'object' &&
          !Array.isArray(item) &&
          !(item instanceof Date) &&
          !(item instanceof RegExp));
}

// 合并默认的中文本地化配置
const localeOptions = {
  chart: {
    locales: [{
      name: 'zh-cn',
      options: {
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        shortDays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        toolbar: {
          download: '下载',
          selection: '选择',
          selectionZoom: '选择缩放',
          zoomIn: '放大',
          zoomOut: '缩小',
          pan: '平移',
          reset: '重置缩放'
        }
      }
    }],
    defaultLocale: 'zh-cn'
  }
}
export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    this.element[this.identifier] = this
  }

  optionsValueChanged(value, _) {
    const mergedOptions = deepMerge({}, localeOptions, value)
    if(!this.chart) {
      this.chart = new ApexCharts(this.element, mergedOptions)
      this.chart.render()
    }else{
      this.chart.updateOptions(mergedOptions)
    }
  }

  destroy() {
    if(this.chart) {
      this.chart.destroy()
    }
  }
}
